// Koda gömülü iki dilli metin: Türkçede Türkçe, diğer dillerde TX_DICT'teki karşılık, yoksa İngilizce.
// Eski kalıp `language === 'tr' ? 'Türkçe' : 'English'` yerine `tx(language, 'Türkçe', 'English')`.
import { TX_DICT } from './tx-dict';

export function tx(language: string, tr: string, en: string): string {
  if (language === 'tr') return tr;
  return (TX_DICT[en] as Record<string, string> | undefined)?.[language] || en;
}
